<template>
    <v-dialog v-model="dialog" max-width="80%" persistent>
        <v-card>
            <v-card-title class="pa-1">
                <v-col cols="12" class="pa-0 text-right">
                    <v-btn icon color="primary" @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" class="pa-0 text-center">
                    <h1>Registros de Integração</h1>
                </v-col>
            </v-card-title>

            <v-card-text class="py-4">
                <v-row>
                    <v-col class="py-0 px-2" cols="12">
                        <v-data-table dense :headers="loteId != null ? headers : headersPagto" :items="lista" :items-per-page="-1" hide-default-footer>
                            <template v-slot:item.data_processamento="{ item }" class="px-1 py-0">
                                <b v-if="item.data_processamento != null">{{ item.data_processamento | formatDateHour }}</b>
                            </template>

                            <template v-slot:item.data_ag_baixa_contabil="{ item }" class="px-1 py-0">
                                <b v-if="item.data_ag_baixa_contabil != null">{{ item.data_ag_baixa_contabil | formatDateHour }}</b>
                            </template>

                            <template v-slot:item.data_finalizado="{ item }" class="px-1 py-0">
                                <b v-if="item.data_finalizado != null">{{ item.data_finalizado | formatDateHour }}</b>
                            </template>

                            <template v-slot:item.data_erro="{ item }" class="px-1 py-0">
                                <b v-if="item.data_erro != null">{{ item.data_erro | formatDateHour }}</b>
                            </template>

                            <template v-slot:item.status="{ item }" class="px-1 py-0">
                                <b><v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on" class="pr-2">
                                                <v-icon :color="colorList[item.status]" small>
                                                    fa fa-exchange-alt
                                                </v-icon>
                                            </span>
                                        </template>
                                        <span class="px-3 py-1 ma-0"
                                            style=" border: solid 1px #999; border-radius: 5px; background-color: #fff;">
                                            {{ labelList[item.status] }}
                                        </span>
                                    </v-tooltip></b>
                            </template>

                            <template v-slot:item.usuario="{ item }" class="px-1 py-0">
                                <b>{{ item.usuario }}</b>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col class="pa-0" cols="12">
                        <v-pagination class="no-box-shadow" v-model="currentPage" :length="pages"
                            @input="getLogs(headers, loteId, currentPage)"></v-pagination>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions v-if="dadosPagamento && dadosPagamento.status < 0" class="px-8">
                <v-btn outlined color="primary" height="30px" small depressed @click="close()">
                    Fechar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" height="30px" small depressed @click="retry(dadosPagamento)">
                    Reenviar
                </v-btn>
            </v-card-actions>
            <v-card-actions v-else class="justify-center py-5">
                <v-btn color="primary" height="30px" small depressed @click="close()">Fechar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from "moment"
export default {
    data() {
        return {
            headers: [
                { text: "Data de processamento", value: "data_processamento", sortable: false },
                { text: "Número do lote", value: "num_lote", sortable: false },
                { text: "Status", value: "status", sortable: false },
                { text: "Mensagem", value: "erro", sortable: false },
            ],
            headersPagto: [
                { text: "Número do lote", value: "num_lote", sortable: true },
                { text: "Em processamento", value: "data_processamento", sortable: false },
                { text: "Aguardando baixa contabil", value: "data_ag_baixa_contabil", sortable: false },
                { text: "Finalizado", value: "data_finalizado", sortable: false },
                { text: "Integrado com erro", value: "data_erro", sortable: false },
                { text: "Erro", value: "erro", sortable: false },
                { text: "Usuário", value: "username", sortable: false }
            ],
            colorList: {
                "0": "primary",
                "1": "#B2B842",
                "2": "#9154CD",
                "3": "#32B88B",
                "-1": "#D0021B",
                "-2": "#FC9D0A",
            },
            labelList: {
                "0": "Não integrado",
                "1": "Em processamento",
                "2": "Aguardando baixa contábil",
                "3": "Pagamento finalizado",
                "-1": "Falha total na integração",
                "-2": "Falha parcial na integração",
            },
            currentPage: 1,
            pages: 1
        }
    },
    filters: {
        formatDateHour(date) {
            return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h'
        },
    },
    watch: {
        totalPages: {
            deep: true,
            handler() {
                this.pages = this.totalPages;
            }
        }
    },
    props: {
        lista: Array,
        close: Function,
        dialog: Boolean,
        retry: Function,
        dadosPagamento: Object,
        getLogs: Function,
        loteId: String,
        totalPages: Number,
    },
}
</script>

<style></style>
